import { createAction } from 'typesafe-actions'
import {InfoModalData} from "../../../entities/InfoModal"

export const adoptConflictSolution = createAction('CMD / ConflictSolution / adopt')<InfoModalData>()
export const acceptRescueConflictSolution = createAction('CMD / RescueConflictSolution  / accept')<InfoModalData>()

export const dontAdoptConflictSolution = createAction('CMD / ConflictSolution / dont adopt')()

export const cancelConflictSolution = createAction('CMD / ConflictSolution / cancel')()

export const stepBackConflictSolution = createAction('CMD / ConflictSolution / step back')()
